import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import Signup from '@/components/Signup.vue'

  import { useRoute, useRouter } from 'vue-router/composables'
  import useIcons from '@/composables/useIcons'
  import useAuthentication from '@/composables/useAuthentication'
  import useI18n from '@/composables/useI18n'
  import useCommonMixin from '@/composables/useCommonMixin'

  import { UserModule } from '@/store/modules/user'

  import Auth0Api from '@/services/api/Auth0Api'

  import CookieHelper from '@/helpers/CookieHelper'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()

  const {
    validator,
    emailErrors,
    passwordErrors,
    signInWithGoogleConnection,
    signInWithFacebookConnection,
    form,
    redirect,
    tokenKey,
  } = useAuthentication()
  const { facebookAvatar, googleAvatar } = useIcons()
  const { translateString } = useI18n()
  const { isKetchUpCompany, isSachkundeCompany } = useCommonMixin()

  const errors = ref([] as { message: string; items: string[] | null }[])
  const errorMessage = ref('')
  const submitting = ref(false)
  const showRegisterForm = ref(false)

  const $v = computed(() => validator.value)

  const signInDirectConnection = () => {
    $v.value.$touch()
    errors.value = []
    if (!$v.value.$invalid) {
      submitting.value = true
      Auth0Api.dbConnectionSignin(form.value.userEmail, form.value.password)
        .then(async (data) => {
          CookieHelper.setCrossDomainCookie(tokenKey.value, data.access_token)

          await UserModule.getUser()

          if (UserModule.onboarded) {
            window.location.href = '/'
            return
          }

          const isAcademySignup = CookieHelper.getCookieValue('is-academy-signup')
          const firstCompany = UserModule.companies.length === 1 ? UserModule.companies[0] : null
          const targetPath = isAcademySignup ? 'registrierung' : 'profile-page'

          if (firstCompany && ['production', 'qa'].includes(process.env.APP_ENV!)) {
            const subdomain = firstCompany.subDomain
            window.location.href = `https://${subdomain}.ketchup.academy/${targetPath}?redirect=${redirect.value}`
          } else {
            router.push({
              path: `/${targetPath}`,
              query: { redirect: redirect.value },
            })
          }
        })
        .catch(() => {
          submitting.value = false
          errorMessage.value = translateString('onboarding.errors.wrongEmailOrPassword')
        })
    }
  }

  const toRegister = () => {
    // TODO remove once we combined the routes
    if (isSachkundeCompany.value && !route.query.testDomain) {
      router.push({ name: 'CustomRegistration' })
    } else {
      showRegisterForm.value = !showRegisterForm.value
    }
  }

return { __sfc: true,route, router, validator, emailErrors, passwordErrors, signInWithGoogleConnection, signInWithFacebookConnection, form, redirect, tokenKey, facebookAvatar, googleAvatar, translateString, isKetchUpCompany, isSachkundeCompany, errors, errorMessage, submitting, showRegisterForm, $v, signInDirectConnection, toRegister, computed, ref, KetchUpButton, LoadingSpinner, Signup, useRoute, useRouter, useIcons, useAuthentication, useI18n, useCommonMixin, UserModule, Auth0Api, CookieHelper }
}

})